export default {"src":"/_next/static/media/docsFrame.d334c2fd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};